//
// locales/vanilla/hy.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/hy.json';
import localeData from 'react-intl/locale-data/hy.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
